import HeaderModule from "../../components/header/HeaderModule";

const DashGeral = () => {
  //A DESENVOLVER
  return (
    <>
      <HeaderModule title="DASHBOARD GERAL" />
    </>
  );
};

export default DashGeral;
